// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type PlayArrow40FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const PlayArrow40Filled: FC<PlayArrow40FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M13.333 31.583V8.25l18.334 11.667-18.334 11.666Z" />
        </svg>
    );
};

export default PlayArrow40Filled;
